import React from "react";
import CalendarMonth from "./CalendarMonth";

type Props = {
  monthDate: Date;
  selectedDays: number[];
  onSelectDay: (day: number) => void;
  onPrevMonth: () => void;
  onNextMonth: () => void;
};

/** Headerless wrapper around CalendarMonth for the PREVIEW. */
const PreviewMonth: React.FC<Props> = ({
  monthDate,
  selectedDays,
  onSelectDay,
  onPrevMonth,
  onNextMonth,
}) => {
  return (
    <div className="preview-cal">
      <CalendarMonth
        monthDate={monthDate}
        selectedDays={selectedDays}
        onToggleDay={(d) => {
          // Only allow clicking on selected days
          if (selectedDays.includes(d)) {
            onSelectDay(d);
          }
        }}
        onPrevMonth={onPrevMonth}
        onNextMonth={onNextMonth}
      />
      {/* flatten any rounded corners inside CalendarMonth */}
      <style>{`
        .preview-cal [class*="rounded"]{ border-radius:0 !important; }
      `}</style>
    </div>
  );
};

export default PreviewMonth;
